<!-- eslint-disable prettier/prettier -->
<template>
    <div class="opt-out-container">
        <div class="opt-out-box">
            <div class="opt-out-grid">
                <div>
                    <img src="@Shared/assets/images/MailIcon.svg" />
                </div>
                <div>
                    <h1 class="opt-out-header">You Have Opted Out of Email Communications</h1>
                </div>
                <div>
                    <p class="opt-out-text">You will no longer receive emails from CommerceHealthcare about your
                        account.</p>
                </div>
                <!-- <div class="mistake-grid">
                    <div>
                        <p class="opt-out-text">Opted out by mistake? </p>
                    </div>
                    <div>
                        <a class="opt-back-in-btn">Opt Back In</a>
                    </div>

                </div> -->
            </div>

        </div>
        <div class="footer">
            <LandingPageFooter />
        </div>
    </div>
</template>
<!-- eslint-disable prettier/prettier -->
<script>
import LandingPageFooter from "../components/LandingPage/LandingPageFooter";
import { mapGetters, mapActions } from "vuex";
export default {
    name: "OptOut",
    components: {
        LandingPageFooter,
    },
    // data() {
    //     return {};
    // },
    // computed: {
    //     ...mapGetters([]),
    // },
    // methods: {
    //     ...mapActions([]),
    // },

};
</script>

<style lang="scss" scoped>
html {
    background-color: #f7f9fa !important;
}

.opt-out-container {
    display: grid;
    grid-template-rows: 1fr;
    align-items: center;
    justify-content: center;
    margin-top: 65px;

    @media all and (max-width: $grid-breakpoint-lg) {
        margin-top: 0px;
    }

    .opt-out-box {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 478px;
        padding: 65px 50px;
        background: var(--Interface-layer-01, #FFF);
        box-shadow: 0px 5px 5px rgba(30, 30, 37, 0.16), 0px 4px 3px 4px rgba(30, 30, 37, 0.1);

        @media all and (max-width: $grid-breakpoint-md) {
            display: grid;
            grid-template-columns: 1fr;
            row-gap: 10%;
            width: auto;
            height: auto;
            padding: 30px;
            height: 0;
            box-shadow: 0px;
        }

        .opt-out-grid {
            display: grid;
            grid-template-rows: repeat(4, auto);
            row-gap: 15px;
            align-items: center;
            justify-content: center;
            text-align: center;

            .opt-out-header {
                font-family: "Poppins";
                font-weight: 500;
                font-size: 32px;
                line-height: 52px;
            }

            .opt-out-text {
                font-family: "Open Sans";
                font-weight: 400;
                font-size: 16px;
                line-height: 26px;
            }

            .mistake-grid {
                display: grid;
                grid-template-columns: repeat(2, auto);
                column-gap: 5px;
                justify-content: center;

                .opt-back-in-btn {
                    font-family: "Open Sans";
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 26px;
                    text-decoration: underline;
                }

            }


        }
    }

    .footer {
        bottom: 0;
        position: fixed;
        width: 100%;
    }
}

.center {
    top: 50%;
    left: 50%;
    text-align: center;
    padding: 20px;

}
</style>